import { render, staticRenderFns } from "./SaleBarChart.vue?vue&type=template&id=2ddcece7&scoped=true&"
import script from "./SaleBarChart.vue?vue&type=script&lang=js&"
export * from "./SaleBarChart.vue?vue&type=script&lang=js&"
import style0 from "./SaleBarChart.vue?vue&type=style&index=0&id=2ddcece7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddcece7",
  null
  
)

export default component.exports